import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Placemark } from 'react-yandex-maps';
import _some from 'lodash/some';

import placemarktIcon from './assets/pizzeria-pin.svg';

class MapPlacemarks extends PureComponent {
  static defaultProps = {
    item: [],
    selectedPolygonId: undefined,
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
    markerHover: PropTypes.func.isRequired,
    selectedPolygonId: PropTypes.any,
    allMarkersVisible: PropTypes.bool,
  };

  onMouseLeave = () => this.props.markerHover(false);

  onMouseEnter = () => this.props.markerHover(true);

  render() {
    const { item, allMarkersVisible, selectedPolygonId } = this.props;

    return (
      <Placemark
        geometry={[parseFloat(item.coordinates[0]), parseFloat(item.coordinates[1])]}
        options={{
          iconLayout: 'default#image',
          iconImageHref: placemarktIcon,
          iconImageSize: [32, 32],
          iconImageOffset: [-16, -32],
          visible:
            selectedPolygonId !== undefined
              ? item.areas_details.length &&
                _some(item.areas_details, { polygon_id: selectedPolygonId })
              : allMarkersVisible,
        }}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      />
    );
  }
}

export default MapPlacemarks;
